import { Component, computed, input, Signal } from '@angular/core';
import { MuiSkeletonAnimationType, MuiSkeletonColor, MuiSkeletonShapeVariant } from '../shared/mui-skeleton-types';


@Component({
  selector: 'mui-skeleton-shape',
  standalone: true,
  templateUrl: './mui-skeleton-shape.component.html',
  styleUrls: ['./mui-skeleton-shape.component.scss', '../shared/mui-skeleton.scss']
})
export class MuiSkeletonShapeComponent {
  type = input<MuiSkeletonShapeVariant>('rect');
  color = input<MuiSkeletonColor>('light');

  animated = input<MuiSkeletonAnimationType>('wave');

  height = input('10px', { transform: this.appendPx });
  width = input('20px', { transform: this.appendPx });

  computedHeight: Signal<string | number> = computed(() => {
    return this.type() === 'tag' ? '1.5rem' : this.height();
  });

  computedRadius: Signal<string> = computed(() => {
    if (this.type() === 'circle') {
      return '50%';
    }
    if (this.type() === 'rect') {
      return '2px';
    }
    if (this.type() === 'tag') {
      return '1rem';
    }
    return '2px';
  });


  appendPx(t: number | string): (string | number) {
    if (/^\d+$/.test(t.toString())) {
      return `${t}px`;
    }
    return t;
  }
}
